import gql from 'graphql-tag'

export default ({ contractId, object, contractCampaigns, contractFiles }) => {
	return {
		mutation: gql`
			mutation (
				$contract_id: bigint!
				$applicant_name: String!
				$applicant_email: String!
				$signature_nop: String
				$name: String!
				$phone: String!
				$email: String!
				$contract_type: bigint!
				$status: String!
				$document: String!
				$signature_type: String!
				$organization_id: bigint!
				$comercial_base: bigint!
				$delegation: String!
				$responsable: String!
				$zipcode: String!
				$domicilio: String!
				$poblacion: String!
				$cellphone: String!
				$contact_person: String!
				$contact_admon: String!
				$iban: String!
				$contract_retention: bigint!
				$representant_nif: String
				$representant_type: String
				$team: String!
				$comercial_category_id: bigint!
				$contract_category: bigint!
				$recommended: String!
				$comments: String!
				$contract_campaigns: [contracts_campaigns_insert_input!]!
				$contract_files: [contracts_files_insert_input!]!
			) {
				update_contracts_by_pk(
					pk_columns: { id: $contract_id }
					_set: {
						applicant_name: $applicant_name
						applicant_email: $applicant_email
						signature_nop: $signature_nop
						name: $name
						phone: $phone
						email: $email
						contract_type: $contract_type
						status: $status
						document: $document
						signature_type: $signature_type
						organization_id: $organization_id
						comercial_base: $comercial_base
						delegation: $delegation
						responsable: $responsable
						zipcode: $zipcode
						domicilio: $domicilio
						poblacion: $poblacion
						cellphone: $cellphone
						contact_person: $contact_person
						contact_admon: $contact_admon
						iban: $iban
						contract_retention: $contract_retention
						representant_nif: $representant_nif
						representant_type: $representant_type
						team: $team
						comercial_category_id: $comercial_category_id
						contract_category: $contract_category
						recommended: $recommended
						comments: $comments
					}
				) {
					id
				}
				delete_contracts_campaigns(
					where: { contract_id: { _eq: $contract_id } }
				) {
					affected_rows
				}
				insert_contracts_campaigns(objects: $contract_campaigns) {
					affected_rows
				}
				delete_contracts_files(where: { contract_id: { _eq: $contract_id } }) {
					affected_rows
				}
				insert_contracts_files(objects: $contract_files) {
					affected_rows
				}
			}
		`,
		variables: {
			contract_id: parseInt(contractId),
			applicant_name: object.applicant_name,
			applicant_email: object.applicant_email,
			signature_nop: object.signature_nop || null,
			name: object.name,
			phone: object.phone,
			email: object.email,
			contract_type: object.contract_type,
			status: object.status,
			document: object.document,
			signature_type: object.signature_type,
			organization_id: object.organization_id,
			comercial_base: object.comercial_base,
			delegation: object.delegation_id,
			responsable: object.responsable_id,
			zipcode: object.zipcode,
			domicilio: object.domicilio,
			poblacion: object.poblacion,
			cellphone: object.cellphone,
			contact_person: object.contact_person,
			contact_admon: object.contact_admon,
			iban: object.iban,
			contract_retention: object.retention_id,
			representant_nif: object.representant_nif || null,
			representant_type: object.representant_type || null,
			team: object.team,
			comercial_category_id: object.comercial_category_id,
			contract_category: object.contract_category,
			recommended: object.recommended,
			comments: object.comments || '',
			contract_campaigns: contractCampaigns.map(elem => ({
				campaign_id: elem.id,
				contract_id: contractId
			})),
			contract_files: contractFiles.map(name => ({
				file_url: name,
				contract_id: contractId
			}))
		}
	}
}
